function formatDeMoney(cents) {
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
    .format(cents / 100)
    .replace(/\s/g, '\u00A0');
}

window.formatDePricesInCollection = function () {
  if (!window.location.pathname.startsWith('/de')) return;

  document
    .querySelectorAll('.de_price--format[data-de-price]')
    .forEach(function (el) {
      const cents = parseInt(el.dataset.dePrice, 10);

      if (!isNaN(cents)) {
        el.textContent = formatDeMoney(cents);
      }
    });
};


// 2. Format Cart Drawer prices using ID
function formatCartDrawerPrices() {
  if (!window.location.pathname.startsWith('/de')) return;
  const drawer = document.getElementById('JJ-CartDrawer-AB');
  if (!drawer) return;
  // A. Format elements that have data-de-price
  drawer.querySelectorAll('.de_price--format[data-de-price]').forEach(function (el) {
    const cents = parseInt(el.dataset.dePrice, 10);
    if (!isNaN(cents)) {
      const formatted = formatDeMoney(cents);
      if (el.textContent !== formatted) {
        el.textContent = formatted;
      }
    }
  });
  // B. Also format any plain text prices in the drawer (e.g. €12.34 -> 12,34 €)
  drawer.querySelectorAll('.jj-cart-drawer__item-price, .jj-cart-drawer__subtotal-value, .highlight').forEach(function (el) {
    let text = el.textContent.trim();
    if (text.includes('€') && !text.endsWith('€')) {
      const formatted = text.replace('€', '').trim() + '\u00A0€';
      el.textContent = formatted.replace('.', ',');
    }
  });
}
// 3. MutationObserver for the Cart Drawer using ID
function initCartDrawerMutation() {
  if (!window.location.pathname.startsWith('/de')) return;
  const drawer = document.getElementById('JJ-CartDrawer-AB');
  if (!drawer) return;
  let isFormatting = false;
  const drawerObserver = new MutationObserver(function (mutations) {
    if (isFormatting) return; // Prevent infinite loop
    isFormatting = true;
    try {
      formatCartDrawerPrices();
    } finally {
      setTimeout(function () {
        isFormatting = false;
      }, 50);
    }
  });
  // Observe items and subtotals updating via AJAX
  drawerObserver.observe(drawer, {
    childList: true,
    subtree: true
  });
  // Run on initial load
  formatCartDrawerPrices();
}


// 2. Format Cart Drawer Prices
window.formatDePrices = function (container) {
  const isDe = window.location.pathname.startsWith('/de') || (window.theme && window.theme.locale === 'de');
  if (!isDe) return;
  const drawer = container || document.getElementById('JJ-CartDrawer-AB');
  if (!drawer) return;
  // A. Format elements that have data-de-price (cents)
  drawer.querySelectorAll('.de_price--format[data-de-price]').forEach(function (el) {
    const cents = parseInt(el.dataset.dePrice, 10);
    if (!isNaN(cents)) {
      const formatted = formatDeMoney(cents);
      if (el.textContent !== formatted) {
        el.textContent = formatted;
      }
    }
  });
  // B. Format any plain text / raw prices (e.g. €12.34 -> 12,34 €)
  drawer.querySelectorAll(
    '.jj-drawer-item-card__price, .jj-drawer-item-card__old-price, .jj-drawer-summary__value, .total-val, .upsell-price-sub, .upsell-price-old, .highlight'
  ).forEach(function (el) {
    let text = el.textContent.trim();
    if (text.includes('€') && !text.endsWith('€')) {
      // Handles formats like €12.34 or € 12.34
      const amount = text.replace('€', '').trim().replace('.', ',');
      el.textContent = amount + '\u00A0€';
    }
  });
};
// 3. MutationObserver for the Cart Drawer
function initCartDrawerMutation() {
  const isDe = window.location.pathname.startsWith('/de') || (window.theme && window.theme.locale === 'de');
  if (!isDe) return;
  const drawer = document.getElementById('JJ-CartDrawer-AB');
  if (!drawer) return;
  let isFormatting = false;
  const drawerObserver = new MutationObserver(function () {
    if (isFormatting) return;
    isFormatting = true;
    try {
      window.formatDePrices(drawer);
    } finally {
      setTimeout(function () {
        isFormatting = false;
      }, 60);
    }
  });
  drawerObserver.observe(drawer, {
    childList: true,
    subtree: true,
    characterData: true
  });
  window.formatDePrices(drawer);
}
// 4. Initial Run & DOM ready listeners
window.formatDePricesInCollection();
document.addEventListener('DOMContentLoaded', function () {
  window.formatDePricesInCollection();
});

